import { SpinnerIcon } from "@/assets/icons";
import { IOptionItem } from "@/components/ui/dropdown/types";
import RadioButton from "@/components/ui/radio";

import { twMerge } from "tailwind-merge";

interface AttributeSelectionProps {
  label: string;
  description?: string;
  items: IOptionItem[];
  isLoading?: boolean;
  selectedValue: string;
  onSelect: (value: string) => void;
}

const AttributeSelection = ({
  label,
  description,
  items,
  selectedValue,
  isLoading = false,
  onSelect
}: AttributeSelectionProps) => (
  <div className="flex flex-col gap-3 mt-4">
    <p className="text-sm text-txtHeading font-semibold">{label}</p>
    <span className="text-xs">{description}</span>
    <div className={twMerge("rounded-xl border border-gainsboro p-3")}>
      <div className="flex flex-col gap-3 max-h-[200px] overflow-y-auto custom-scrollbar">
        {isLoading ? (
          <div className="flex flex-1 items-center justify-center p-3">
            <SpinnerIcon
              data-testid="attribute-selection-spinner"
              className="w-6 h-6 animate-spin text-light-gray"
            />
          </div>
        ) : (
          items.map((item) => (
            <RadioButton
              key={item.value}
              name={`attribute-selection-${item.value}`}
              checked={selectedValue === item.value}
              onCheck={() => onSelect(item.value)}
              label={item.label}
              inputClassName="w-5 h-5 border-dim-gray"
              labelClassName="text-xs font-normal text-txtHeading"
            />
          ))
        )}
      </div>
    </div>
  </div>
);

export default AttributeSelection;
